if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
if (!window.bergImageVariantClickInstalled) {
  window.bergImageVariantClickInstalled = true;

  document.addEventListener('click', (event) => {
    const gallery = event.target.closest('media-gallery');
    if (!gallery) return;

    const thumbnail = event.target.closest('[data-target]');
    const imageOpener = event.target.closest(
      '.product__modal-opener--image'
    );

    if (!thumbnail && !imageOpener) return;

    const mediaElement =
      thumbnail || imageOpener.closest('[data-media-id]');

    const mediaKey =
      mediaElement?.dataset.target ||
      mediaElement?.dataset.mediaId;

    if (!mediaKey) return;

    const mediaId = mediaKey.split('-').pop();
    const productInfo = gallery.closest('product-info');
    const picker = productInfo?.querySelector('variant-selects');
    const mapping = gallery.querySelector('[data-image-variants]');

    if (!picker || !mapping) return;

    let variants;
    try {
      variants = JSON.parse(mapping.textContent);
    } catch {
      return;
    }

    const candidates = variants.filter(
      (variant) => String(variant.mediaId) === mediaId
    );
    if (!candidates.length) return;

    const groups = Array.from(
      picker.querySelectorAll(
        'fieldset, .product-form__input--dropdown'
      )
    );

    const currentValues = groups.map((group) => {
      const select = group.querySelector('select');
      return select
        ? select.value
        : group.querySelector('input:checked')?.value;
    });

    // Prefer the variant that preserves the most current choices.
    const score = (variant) =>
      variant.options.reduce(
        (total, value, index) =>
          total + (value === currentValues[index] ? 1 : 0),
        0
      );

    const variant = candidates.reduce((best, candidate) =>
      score(candidate) > score(best) ? candidate : best
    );

    if (variant.options.length !== groups.length) return;

    const controls = groups.map((group, index) => {
      const select = group.querySelector('select');
      const value = variant.options[index];

      if (select) {
        const option = Array.from(select.options).find(
          (item) => item.value === value
        );
        return option ? { select, option } : null;
      }

      const radio = Array.from(
        group.querySelectorAll('input[type="radio"]')
      ).find((item) => item.value === value);

      return radio ? { radio } : null;
    });

    if (controls.some((control) => !control)) return;

    const needsChange = variant.options.some(
      (value, index) => value !== currentValues[index]
    );
    if (!needsChange) return;

    // A linked main-image click selects the variant instead of zooming.
    if (imageOpener) {
      event.preventDefault();
      event.stopPropagation();
    }

    let changeTarget;

    controls.forEach((control) => {
      if (control.select) {
        control.select.value = control.option.value;
        Array.from(control.select.options).forEach((option) => {
          option.toggleAttribute(
            'selected',
            option === control.option
          );
        });
        changeTarget = control.select;
      } else {
        control.radio.checked = true;
        changeTarget = control.radio;
      }

      picker.updateSelectionMetadata({ target: changeTarget });
    });

    // Let the theme update price, stock, URL and purchase variant.
    changeTarget.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }, true);
}
